import { render, staticRenderFns } from "./TermFeeRequestStudent.vue?vue&type=template&id=1ebec0c8"
import script from "./TermFeeRequestStudent.vue?vue&type=script&lang=js"
export * from "./TermFeeRequestStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports